<template>
    <div class="page">
        <div class="images fadeIn">
            <div class="text_11">post post scriptum</div>
            <div class="slider_hero">
                <swiper
                    v-if="croppedImgs"
                    :options="croppedImgs.length > 1 ? heroSliderOptions : heroSliderOptionsWithOneSlide">
                    <swiper-slide v-for="(image, index) in croppedImgs" :key="index">
                        <component
                            :is="image.link ? 'NuxtLink' : 'div'"
                            :to="image.link"
                            aria-label=""
                            :aria-labelledby="`#slider-text-${index}`">
                            <div v-if="image.video.mp4 || image.video.webm">
                                <video playsinline muted autoplay loop v-lazy-load :data-poster="image.src" data-not-lazy>
                                    <source v-lazy-load :data-src="image.video.mp4" type="video/mp4" data-not-lazy />
                                    <source v-lazy-load :data-src="image.video.webm" type="video/webm" data-not-lazy />
                                </video>
                                <div
                                    v-if="image.text"
                                    :id="`slider-text-${index}`"
                                    class="image__title"
                                    v-html="image.text"></div>
                            </div>
                            <div class="image__imgs" v-else>
                                <template v-if="$device.isDesktop">
                                    <UiImage
                                        v-if="image.src"
                                        :path="image.src"
                                        :mobile="{ width: image.dimensions.m[0], height: image.dimensions.m[1] }"
                                        :desktop="{
                                            width: image.dimensions.d[0],
                                            height: image.dimensions.d[1],
                                        }"></UiImage>
                                    <UiImage
                                        v-if="image.src2"
                                        :path="image.src2"
                                        :mobile="{ width: image.dimensions.m[0], height: image.dimensions.m[1] }"
                                        :desktop="{
                                            width: image.dimensions.d[0],
                                            height: image.dimensions.d[1],
                                        }"></UiImage>
                                </template>
                                <template v-else>
                                    <UiImage
                                        v-if="image.srcMobile"
                                        :path="image.srcMobile"
                                        :mobile="{ width: image.dimensions.m[0], height: image.dimensions.m[1] }"
                                        :desktop="{
                                            width: image.dimensions.d[0],
                                            height: image.dimensions.d[1],
                                        }"></UiImage>
                                    <UiImage
                                        v-if="image.src2Mobile"
                                        :path="image.src2Mobile"
                                        :mobile="{ width: image.dimensions.m[0], height: image.dimensions.m[1] }"
                                        :desktop="{
                                            width: image.dimensions.d[0],
                                            height: image.dimensions.d[1],
                                        }"></UiImage>
                                </template>
                                <div v-if="image.text" class="image__title" v-html="image.text"></div>
                            </div>
                        </component>
                    </swiper-slide>
                </swiper>
            </div>
        </div>

        <div class="index-block items-block" v-for="(block, index) in blocks" :key="index">
            <nuxt-link class="index-block__title text_13" :class="block.color_class" v-if="block.link" :to="block.link"
                >{{ block.name }}
            </nuxt-link>
            <div class="index-block__title text_13" v-else>
                {{ block.name }}
            </div>
            <div class="index-block__content">
                <swiper :options="swiperOptions" v-if="$device.isDesktop">
                    <swiper-slide v-for="(item, i_index) in block.items" :key="i_index" :index="i_index + 1">
                        <template v-if="block.items.length - 1 == i_index">
                            <nuxt-link :to="block.link">
                                <div class="category-link-text">
                                    {{ $t("block_category_link") }}
                                </div>
                                <div class="category-link-shadow"></div>
                                <UiImage
                                    width="100%"
                                    v-if="item.sku.images[0] && item.sku.images[0].path"
                                    :path="item.sku.images[0].path"
                                    :mobile="cropSize.mobile"
                                    :desktop="cropSize.desktop"></UiImage>
                            </nuxt-link>
                        </template>
                        <template v-else>
                            <Product
                                :data="item.sku"
                                is-for-slider
                                v-if="item.type === 'product'"
                                :is-manual-lazy-image="true" />
                            <a :href="item.url" v-if="item.type === 'image'">
                                <!--                                <img-->
                                <!--                                    v-lazy-load :data-src="$img.resizeOld(item.image.path, cropSize)"-->
                                <!--                                    v-lazy-load :data-srcset="$img.resizeOld(item.image.path, cropSize2x) + ' 2x'"-->
                                <!--                                    width="100%"-->
                                <!--                                    data-not-lazy-->
                                <!--                                />-->
                                <UiImage
                                    width="100%"
                                    :path="item.image.path"
                                    :mobile="cropSize.mobile"
                                    :desktop="cropSize.desktop"></UiImage>
                            </a>
                        </template>
                    </swiper-slide>

                    <div slot="button-prev" class="splide__arrow splide__arrow--prev"></div>
                    <div slot="button-next" class="splide__arrow splide__arrow--next"></div>
                </swiper>
                <div class="index-block__native-slider" v-else>
                    <div
                        class="index-block__native-slider-item"
                        v-for="(item, i_index) in block.items"
                        :key="i_index"
                        :index="i_index + 1">
                        <template v-if="block.items.length - 1 == i_index">
                            <nuxt-link :to="block.link" class="mobile-block-category-link">
                                <div class="category-link-text">
                                    {{ $t("block_category_link") }}
                                </div>
                                <div class="category-link-shadow"></div>

                                <UiImage
                                    width="100%"
                                    :path="item.sku.images[0].path"
                                    :mobile="cropSize.mobile"
                                    :desktop="cropSize.desktop"></UiImage>
                            </nuxt-link>
                        </template>
                        <template v-else>
                            <Product
                                is-for-slider
                                :data="item.sku"
                                v-if="item.type === 'product'"
                                :is-manual-lazy-image="true" />
                            <a :href="item.url" v-if="item.type === 'image'">
                                <UiImage
                                    width="100%"
                                    :path="item.image.path"
                                    :mobile="cropSize.mobile"
                                    :desktop="cropSize.desktop"></UiImage>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="row flex-row row--fullwidth"></div>
            </div>
        </div>
        <div class="row row--fullwidth">
            <div class="col lg-6 sm-12 col--no-padding" v-for="(selection, index) in selections" :key="index">
                <div class="index-block items-block">
                    <div class="index-block__title text_13">{{ selection.name }}</div>
                    <div class="index-block__content">
                        <nuxt-link :to="selection.url">
                            <UiImage
                                width="100%"
                                :path="selection.image.path"
                                :mobile="cropSize.mobile"
                                :desktop="cropSize.desktop"></UiImage>
                        </nuxt-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="index-block">
            <Insta></Insta>
        </div>
    </div>
</template>
<script>
import Product from "@/components/Product";
import Insta from "@/components/Insta";

import { mapGetters } from "vuex";
import { Swiper, SwiperSlide } from "@/plugins/swiper.client";
import UiImage from "../components/ui/Image.vue";

export default {
    name: "promo",
    components: { UiImage, Product, Insta, Swiper, SwiperSlide },
    async asyncData({ $axios }) {
        const requests = [$axios.get("/api/slides")];
        const seo = await $axios.get("/api/seo/promo");
        const [images] = await Promise.all(requests);

        return {
            images: images.data,
            seo: seo.data,
        };
    },
    head() {
        // let preloadArray = this.images.map((el) => {
        //     return {
        //         rel: "preload",
        //         as: "image",
        //         href: this.$img.resizeOld(el.image.path, this.getSize(el.size), "crop"),
        //     };
        // });
        // let preloadArray2x = this.images.map((el) => {
        //     return {
        //         rel: "preload",
        //         as: "image",
        //         href: this.$img.resizeOld(el.image.path, this.getSize(el.size, true), "crop"),
        //     };
        // });
        return {
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "keywords",
                    property: "keywords",
                    content: this.seo?.keywords ? this.seo.keywords : "",
                },
            ],
        };
    },
    data() {
        return {
            seo: {},
            selectedItems: [],
            newItems: [],
            sliderOptions: {
                perPage: this.$device.isMobile ? 2 : 4,
                pagination: false,
                arrows: !this.$device.isMobile,
                drag: "free",
            },
            swiperOptions: {
                slidesPerView: this.$device.isMobile ? 2 : 4,
                navigation: {
                    nextEl: ".splide__arrow--next",
                    prevEl: ".splide__arrow--prev",
                },
                keyboard: { enabled: true, onlyInViewport: false },
                mousewheel: {
                    forceToAxis: true,
                },
                freeMode: true,
            },
            heroSliderOptions: {
                slidesPerView: this.$device.isMobile ? 1 : 2,
                rewind: true,
                speed: 2500,
                autoplay: {
                    delay: 5500,
                    disableOnInteraction: false,
                },
            },
            heroSliderOptionsWithOneSlide: {
                slidesPerView: 1,
                rewind: true,
                speed: 2500,
            },
            blocks: null,
            selections: null,
        };
    },
    watch: {
        async locale() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapGetters({
            locale: "globalvars/getLang",
        }),
        cropSize() {
            return { desktop: { width: 630, height: 950 }, mobile: { width: 216, height: 324 } };
        },
        croppedImgs() {
            if (this.images.length > 0) {
                return this.images.map((item) => {
                    return {
                        link: item.url,
                        text: item.text,
                        src: item.image.path,
                        srcMobile: item.mobile_image?.path || null,
                        src2: item.second_image?.path || null,
                        src2Mobile: item.second_mobile_image?.path || null,
                        dimensions: this.getSize(item.size),
                        size: item.size,
                        video: {
                            mp4:
                                this.$device.isDesktop && item.video_mp4
                                    ? item.video_mp4.path
                                    : !this.$device.isDesktop && item.video_mp4_mobile
                                    ? item.video_mp4_mobile.path
                                    : null,
                            webm:
                                this.$device.isDesktop && item.video_webm
                                    ? item.video_webm.path
                                    : !this.$device.isDesktop && item.video_webm_mobile
                                    ? item.video_webm_mobile.path
                                    : null,
                        },
                    };
                });
            }
            return null;
        },
    },
    methods: {
        getSize(size) {
            return {
                d: size == "single" ? [1900, 1010] : [950, 1010],
                m: [414, 552],
            };
        },
        lazyLoadImage(e) {
            let media = e.querySelectorAll("[data-manual-lazy]");

            [...media].forEach((m) => this.$lazyLoad(m));
        },
        checkVisibleBlocks() {
            const blocks = document.querySelectorAll(".items-block");

            [...blocks].forEach((block) => {
                const rect = block.getBoundingClientRect();
                const elemTop = rect.top;
                const elemBottom = rect.bottom;

                const isVisible = elemTop < window.innerHeight && elemBottom >= 0;

                if (isVisible) this.lazyLoadImage(block);
            });
        },
    },
    async fetch() {
        if (this.$route.query.token) {
            this.$auth
                .loginWith("cookie", { data: { token: this.$route.query.token } })
                .then((res) => {
                    this.$gtm.push({
                        event: "GAevent",
                        eventCategory: "user",
                        eventAction: "send",
                        eventLabel: "entrance",
                        userId: res.data.data.retail_id,
                    });
                    this.$router.push("/");
                    window.reload;
                })
                .catch((error) => {
                    console.log(`error =>`, error.response.data);
                });
        }
        const requests = [this.$axios.$get(`/api/blocks?lang=${this.locale.lang}`)];
        const [blocks] = await Promise.all(requests);

        blocks.map((block) => {
            block.items = block.items.filter((el) => el.sku || el.image);
        });
        this.blocks = blocks;
    },
    mounted() {
        localStorage.removeItem("enPop_showState");

        //this.checkVisibleBlocks();

        //window.addEventListener("scroll", () => {
        //    this.checkVisibleBlocks();
        // });

        // this.products_to_vk = [];
        // if (this.newItems) {
        //     this.newItems.forEach((element) => {
        //         this.products_to_vk.push({
        //             id: element.id,
        //             price: element.price,
        //         });
        //     });
        // }
    },
};
</script>
<style lang="less">
@media @sm {
    .swiper-container .splide__arrow {
        transform: translateY(-58px);
    }
}

.items-block {
    a {
        height: 100%;
        display: block;

        img {
            height: 100%;
            object-fit: cover;
            width: 100%;
            display: block;
        }
    }
}

.image__title {
    a {
        display: inline-flex;
        align-items: center;
        font-size: 25px;

        &:after {
            content: "";
            display: block;
            width: 40px;
            height: 15px;
            margin-left: 15px;
            background: url(../assets/icons/arrow-right.svg) center left / contain no-repeat;
        }

        &:hover {
            color: #000 !important;
            opacity: 0.8;
        }

        * {
            margin-bottom: 0;
        }
    }

    span[style*="255"] {
        a {
            &:after {
                filter: invert(1);
                -webkit-filter: invert(1);
            }

            &:hover {
                color: #fff !important;
                opacity: 0.8;
            }
        }
    }

    strong {
        font-weight: 700;
    }

    em {
        font-style: italic;
    }
}
</style>
<style scoped lang="less">
.images {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    opacity: 0;

    .text_11 {
        position: absolute;
        width: 100%;
        top: 20px;
        text-align: center;
        z-index: 0;
    }

    .slider_hero {
        position: relative;
        display: block;
        width: 100%;

        .image {
            padding-top: 0px;

            .image__holder {
                position: relative;
                left: auto;
                top: auto;
                right: auto;
                bottom: auto;
            }
        }
    }
}

.image {
    width: 50%;
    position: relative;
    padding-top: 53%;
    overflow: hidden;

    &:hover {
        .image__title:after {
            transform: translate(15px);
        }
    }

    @media @sm {
        padding-top: 0;
    }
    z-index: 1;
    @media @sm {
        width: 100%;
    }

    &__title {
        position: absolute;
        bottom: 30px;
        left: 32px;
        right: 32;
        font-weight: 300;
        font-size: 25px;
        line-height: 100%;
        /* identical to box height, or 25px */

        letter-spacing: 0.03em;
        display: flex;
        align-items: center;
        @media @sm {
            font-size: 18px;
        }

        &:after {
            content: "";
            margin-left: 14px;
            display: inline-block;
            vertical-align: middle;
            width: 40px;
            height: 22px;
            .trs(transform);
            background: url(../assets/icons/arrow-right.svg?inline) center left / contain no-repeat;
            filter: invert(1);
        }
    }

    &--double {
        width: 100%;
    }

    &__imgs {
        position: relative;

        picture + picture {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            position: absolute;
            opacity: 0;
            .trs(opacity, 0.3s, 3s);

            .fadeIn & {
                opacity: 1;
                transform: translateZ(0);
                backface-visibility: hidden;
                animation: slowFlash 6s 3s ease infinite;
            }
        }
    }

    &__holder {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        @media @sm {
            position: static;
        }
    }

    img,
    video {
        width: 100%;
        object-fit: cover;
        display: block;
    }
}

@keyframes slowFlash {
    0%,
    20% {
        opacity: 0;
    }
    28%,
    70% {
        opacity: 1;
    }
    78%,
    100% {
        opacity: 0;
    }
}

.index-block {
    &__title {
        padding: 64px 32px 32px;
        @media @sm {
            padding: 40px 16px 16px;
        }
    }

    &__native-slider {
        overflow-x: scroll;
        display: flex;

        .product {
            width: 50vw;
        }
    }
}

::v-deep .splide {
    &__pagination {
        bottom: 100%;
        right: 0;
        width: auto;
        transform: none;
        justify-content: flex-end;
        padding: 0 16px;
        margin-bottom: 19px;

        &__page {
            width: 6px;
            height: 6px;
            background: @border2;
            border-radius: 0;
            margin: 0 5px;
            transform: rotate(45deg);
            opacity: 1;

            &.is-active {
                transform: rotate(45deg);
                background: #000;
            }
        }
    }
}

.index-block__title.text_13.red-title {
    color: #ff161a;
}

.swiper-slide {
    height: auto;
}

.category-link-shadow {
    width: 100%;
    position: absolute;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
}

.category-link-text {
    z-index: 101;
    position: absolute;
    color: white;
    align-items: center;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
}

.mobile-block-category-link {
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 62vw;
    height: 100%;
    display: flex;
    transition: background 0.3s 0s ease;
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDU0IDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBvcGFjaXR5PSIwLjIiIGQ9Ik0zIDBMMCAzTDMgNkw2IDNMMyAwWiIgZmlsbD0iYmxhY2siPg0KICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJvcGFjaXR5IiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswLjUgMCAxIDAuNTswLjUgMC41IDAuNSAwLjUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjAuMjsxOzAuMjswLjIiIGtleVRpbWVzPSIwOzAuMzswLjY7MSIgZHVyPSIxcyIgYmVnaW49Ii0wLjZzIj48L2FuaW1hdGU+DQo8L3BhdGg+DQo8cGF0aCBvcGFjaXR5PSIwLjIiIGQ9Ik0yNyAwTDI0IDNMMjcgNkwzMCAzTDI3IDBaIiBmaWxsPSJibGFjayI+DQogIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9Im9wYWNpdHkiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAuNSAwIDEgMC41OzAuNSAwLjUgMC41IDAuNSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIHZhbHVlcz0iMC4yOzE7MC4yOzAuMiIga2V5VGltZXM9IjA7MC4zOzAuNjsxIiBkdXI9IjFzIiBiZWdpbj0iLTAuMzk5OTk5OTk5OTk5OTk5OTdzIj48L2FuaW1hdGU+DQo8L3BhdGg+DQo8cGF0aCBkPSJNNTEgMEw0OCAzTDUxIDZMNTQgM0w1MSAwWiIgZmlsbD0iYmxhY2siPg0KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9Im9wYWNpdHkiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAuNSAwIDEgMC41OzAuNSAwLjUgMC41IDAuNSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIHZhbHVlcz0iMC4yOzE7MC4yOzAuMiIga2V5VGltZXM9IjA7MC4zOzAuNjsxIiBkdXI9IjFzIiBiZWdpbj0iLTAuMTk5OTk5OTk5OTk5OTk5OThzIj48L2FuaW1hdGU+DQo8L3BhdGg+DQo8L3N2Zz4NCg==)
        center no-repeat;
    margin: 0 1px;
    padding: 0;
}
</style>
<style>
.is_desktop .slider_hero .splide__slide:nth-child(2n) {
    left: -1px;
}
</style>
